import { useConfigStore } from '@/stores/configStore';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

export const loadConfig = async () => {
  const configStore = useConfigStore();
  await configStore.loadConfig();
};

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export default pinia;
